"use client";

import { useRef, useState } from "react";

interface FAQItem {
  question: string;
  answer: React.ReactNode;
}

const faqList: FAQItem[] = [
  {
    question: "What do I get exactly?",
    answer: <div className='space-y-2 leading-relaxed'>Loreum Ipseum</div>,
  },
  {
    question: "Can I get a refund?",
    answer: (
      <p>
        Yes! You can request a refund within 7 days of your purchase. Reach out
        by email.
      </p>
    ),
  },
  {
    question: "I have another question",
    answer: (
      <div className='space-y-2 leading-relaxed'>Cool, contact us by email</div>
    ),
  },
];

interface ItemProps {
  item: FAQItem;
}

const Item: React.FC<ItemProps> = ({ item }) => {
  const accordion = useRef<HTMLDivElement>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <li>
      <button
        className='relative flex gap-2 items-center w-full py-5 text-base font-semibold text-left border-t md:text-lg border-white/10 text-white'
        onClick={(e) => {
          e.preventDefault();
          setIsOpen(!isOpen);
        }}
        aria-expanded={isOpen}
      >
        <span
          className={`flex-1 ${
            isOpen ? "text-bb-primary" : "text-white"
          }`}
        >
          {item?.question}
        </span>
        <svg
          className={`flex-shrink-0 w-4 h-4 ml-auto fill-current`}
          viewBox='0 0 16 16'
          xmlns='http://www.w3.org/2000/svg'
        >
          <rect
            y='7'
            width='16'
            height='2'
            rx='1'
            className={`transform origin-center transition duration-200 ease-out ${
              isOpen && "rotate-180"
            }`}
          />
          <rect
            y='7'
            width='16'
            height='2'
            rx='1'
            className={`transform origin-center rotate-90 transition duration-200 ease-out ${
              isOpen && "rotate-180 hidden"
            }`}
          />
        </svg>
      </button>

      <div
        ref={accordion}
        className={`transition-all duration-300 ease-in-out opacity-80 overflow-hidden text-white`}
        style={
          isOpen
            ? { maxHeight: accordion?.current?.scrollHeight, opacity: 1 }
            : { maxHeight: 0, opacity: 0 }
        }
      >
        <div className='pb-5 leading-relaxed'>{item?.answer}</div>
      </div>
    </li>
  );
};

const FAQ: React.FC = () => {
  return (
    <section className='bg-gradient-to-b from-[#191919] to-[#2B2B2B]' id='faq'>
      <div className='py-24 px-8 max-w-7xl mx-auto flex flex-col md:flex-row gap-12'>
        <div className='flex flex-col text-left basis-1/2'>
          <p className='inline-block font-semibold text-bb-primary mb-4'>FAQ</p>
          <p className='sm:text-4xl text-3xl font-extrabold text-white '>
            Frequently Asked Questions
          </p>
        </div>

        <ul className='basis-1/2'>
          {faqList.map((item, i) => (
            <Item key={i} item={item} />
          ))}
        </ul>
      </div>
    </section>
  );
};

export default FAQ;
